<template>
  <div>
    <div class="row">
      <!-- Breadcrumb -->
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">
                {{ $t("configuracionCarta") }}
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Diagnóstico
            </li>
          </ol>
        </nav>
      </div>

      <!-- Selección de negocio -->
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="handleBusinessChange"
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Caso: Sin negocios con errores -->
      <template v-if="permiso === 1">
        <div class="col-md-12">
          <div class="alert alert-success" role="alert">
            <i class="fas fa-check-circle" style="margin-right: 0.5%"></i>
            <strong>{{ activeTab === 'productos' ? $t("sinErroresProductos") : $t("sinErroresMateriasPrimas") }}</strong>
            {{ $t("enEsteNegocio") }}
          </div>
        </div>
      </template>

      <!-- Caso: Negocio con acceso y diagnóstico -->
      <template v-else-if="permiso && respuesta">
        <div class="tabs-container">
          <div
            class="tab"
            :class="{ active: activeTab === 'productos' }"
            @click="diagnosisProducts"
          >
            <i class="fas fa-utensils"></i> Productos
          </div>
          <div
            class="tab"
            :class="{ active: activeTab === 'materias' }"
            @click="diagnosisSubproducts"
          >
            <i class="fas fa-seedling"></i> Materias primas
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <!-- Tab de Productos -->
              <div class="col-md-12" v-if="activeTab === 'productos'">
                <div v-if="productosErroneos.length > 0">
                  <div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
                    <p class="mb-0 py-2">
                      {{ $t("actualizarProductos") }}
                      <strong>{{ productosErroneos.length }}</strong>
                      {{ productosErroneos.length > 1 ? $t("productos") : $t("producto") }}
                      {{ $t("enEsteNegocio") }}
                    </p>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>Nombre</th>
                          <th>{{ $t("categoria") }}</th>
                          <th>{{ $t("activoEnTPV") }}</th>
                          <th>{{ $t("productoRelacionadoConTpv") }}</th>
                          <th>{{ $t("Acciones") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(pro, index) in productosErroneos" :key="index">
                          <td>{{ pro.nameProducto }}</td>
                          <td>{{ pro.catProd }}</td>
                          <td>
                            <span v-if="pro.activoTpv == 0 || pro.activoTpv == null">
                              <span class="text-danger">NO</span>
                              <router-link
                                v-if="pro.idProductoTPV != null"
                                :to="{
                                  name: 'ProductoForm',
                                  params: {
                                    idBusiness: idBusiness,
                                    idProducto: pro.idProductoTPV,
                                    idUser: parseJwt($store.getters.jwt).idUser,
                                  },
                                }"
                              >
                                <i
                                  class="fas fa-pen"
                                  style="margin-left: 10%; color: orange"
                                  v-tooltip="$i18n.t('editarProductoTpv')"
                                ></i>
                              </router-link>
                            </span>
                            <span v-else class="text-success">SÍ</span>
                          </td>
                          <td>
                            <span v-if="pro.idProductoTPV == null">No tiene relación</span>
                            <span v-else>{{ pro.nameProductoProducto }}</span>
                          </td>
                          <td>
                            <router-link
                              :to="{
                                name: 'producto-carta',
                                params: {
                                  idBusiness: idBusiness,
                                  idCarta: idCarta,
                                  idProducto: pro.id,
                                },
                              }"
                            >
                              <i
                                class="fas fa-pen"
                                style="margin-left: 10%; color: orange"
                                v-tooltip="$i18n.t('editarProductoCarta')"
                              ></i>
                            </router-link>
                            <i
                              class="fas fa-link"
                              style="color: gray; cursor: pointer; margin-left: 40%"
                              v-tooltip="$i18n.t('relacionarProducto')"
                              @click="abrirRelacionadorProducto(pro.id, pro.nameProducto)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else class="alert alert-success" role="alert">
                  <i class="fas fa-check-circle" style="margin-right: 0.5%"></i>
                  <strong>{{ $t("sinErroresProductos") }}</strong>
                  {{ $t("enEsteNegocio") }}
                </div>
              </div>

              <!-- Tab de Materias primas -->
              <div class="col-md-12" v-if="activeTab === 'materias'">
                <div v-if="subproductosErroneos.length > 0">
                  <div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
                    <p class="mb-0 py-2">
                      {{ $t("actualizarProductos") }}
                      <strong>{{ subproductosErroneos.length }}</strong>
                      {{ subproductosErroneos.length > 1 ? $t("materiasPrimas") : $t("materiaPrima") }}
                      {{ $t("enEsteNegocio") }}
                    </p>
                  </div>
                  <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>Nombre</th>
                          <th>{{ $t("Activo en TPV") }}</th>
                          <th>{{ $t("productoRelacionadoConTpv") }}</th>
                          <th>{{ $t("acciones") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(s, index) in subproductosErroneos" :key="index">
                          <td>{{ s.name }}</td>
                          <td>
                            <span v-if="s.activoTpv == 1 || s.idSubproductoTPV == null">
                              <span class="text-danger">NO</span>
                              <router-link
                                v-if="s.idSubproductoTPV != null"
                                :to="{
                                  name: 'materiaForm',
                                  params: {
                                    idBusiness: idBusiness,
                                    idSubproduct: s.idSubproductoTPV,
                                    idUser: parseJwt($store.getters.jwt).idUser,
                                    idCarta: idCarta,
                                  },
                                }"
                              >
                                <i
                                  class="fas fa-pen"
                                  style="margin-left: 10%; color: orange"
                                  v-tooltip="$i18n.t('editarMateriaPrimaTpv')"
                                ></i>
                              </router-link>
                            </span>
                            <span v-else class="text-success">SÍ</span>
                          </td>
                          <td>
                            <span v-if="s.idSubproductoTPV == null">No tiene relación</span>
                            <span v-else>{{ s.subproductName }}</span>
                          </td>
                          <td>
                            <router-link
                              :to="{
                                name: 'materia-prima-carta',
                                params: {
                                  idBusiness: idBusiness,
                                  idMateriaPrima: s.id,
                                  idCarta: idCarta,
                                },
                              }"
                            >
                              <i
                                class="fas fa-pen"
                                style="margin-left: 10%; color: orange"
                                v-tooltip="$i18n.t('editarMateriaPrimaCarta')"
                              ></i>
                            </router-link>
                            <i
                              class="fas fa-link"
                              style="color: gray; cursor: pointer; margin-left: 40%"
                              v-tooltip="$i18n.t('relacionarProducto')"
                              @click="abrirRelacionSubproducto(s.id, s.name)"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else class="alert alert-success" role="alert">
                  <i class="fas fa-check-circle" style="margin-right: 0.5%"></i>
                  <strong>{{ $t("sinErroresMateriasPrimas") }}</strong>
                  {{ $t("enEsteNegocio") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- Caso: Sin acceso al módulo -->
      <template v-else>
        <div class="col-md-12">
          <div class="alert alert-primary" role="alert">
            <i class="fas fa-exclamation-circle" style="margin-right: 0.5%"></i>
            <strong>{{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}</strong>
            {{ $t("paraMasInformacionContacteConSu") }}
            <strong>{{ $t("distribuidor") }}</strong>.
          </div>
        </div>
      </template>

      <!-- Modal para relacionar producto -->
    <b-modal
  id="modal-producto"
  v-model="dialogVisible"
  :title="productoName"
  centered
  hide-footer
>
  <p class="mb-3">
    Utilice el buscador para relacionar el producto de la carta con el producto en el TPV
  </p>
  <label class="d-block mb-2">
    <strong>Seleccionar producto</strong><span style="color: red">*</span>
  </label>
  <el-select
    class="select-default mb-4"
    v-model="producto.idProduct"
    filterable
    remote
    :remote-method="searchProductos"
    :placeholder="$t('nombreDelProductoEnElTpv')"
  >
    <el-option
      v-for="item in productos"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
  <div class="d-flex justify-content-end gap-2">
    <b-button style="margin-right: 12px;" class="btn-spacing" variant="secondary" @click="dialogVisible = false">Cancelar</b-button>
    <b-button variant="primary" @click="guardarProducto">Guardar</b-button>
  </div>
</b-modal>

    <!-- Modal para relacionar subproducto -->
    <b-modal
      id="modal-subproducto"
      v-model="dialogVisible2"
      title="Seleccionar Materia Prima"
      centered
      hide-footer
    >
      <p class="mb-3">
        Utilice el buscador para relacionar la materia prima de la carta con el TPV
      </p>
      <label class="d-block mb-2">
        <strong>{{ subproductoName }}</strong><span style="color: red">*</span>
      </label>
      <el-select
        class="select-default mb-4"
        v-model="materiaPrima.idSubproduct"
        filterable
        remote
        :remote-method="searchMateriasPrimas"
        :placeholder="$t('nombreDeLaMateriaPrimaEnElTpv')"
      >
        <el-option
          v-for="s in listMateriasPrimas"
          :key="s.id"
          :label="s.name"
          :value="s.id"
        />
      </el-select>
      <div class="d-flex justify-content-end gap-2">
        <b-button style="margin-right: 12px;" class="btn-spacing" variant="secondary" @click="dialogVisible2 = false">Cancelar</b-button>
        <b-button variant="primary" @click="guardarSubproducto">Guardar</b-button>
      </div>
    </b-modal>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";

export default {
  name: "DiagnosticoCarta",
  data() {
    return {
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,
      respuesta: true,
      productosErroneos: [],
      subproductosErroneos: [],
      idCarta: 0,
      dialogVisible: false,
      dialogVisible2: false,
      productoId: null,
      producto: { idProduct: null },
      productos: [],
      subproductoId: null,
      materiaPrima: { idSubproduct: null },
      listMateriasPrimas: [],
      productoName: null,
      subproductoName: null,
      activeTab: "productos",
    };
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.notificarProductoSubproductoUpdate();
  },
  methods: {
    permisoCarta() {
      const config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then((response) => {
          this.respuesta = response.data.response && response.data.result;
          this.permiso = response.data.result ? response.data.result.permiso : false;
          this.loading.close();
        })
        .catch((error) => {
          console.error("Error en permisoCarta:", error);
          this.respuesta = false;
          this.permiso = false;
          this.loading.close();
        });
    },
    getBusiness() {
      const config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then((response) => {
          this.listBusinesses = response.data.result || [];
          if (this.listBusinesses.length > 0) {
            this.idBusiness = this.listBusinesses[0].id;
            this.permisoCarta();
            this.diagnosisProducts();
          } else {
            this.permiso = 1;
            this.respuesta = false;
            this.loading.close();
          }
        })
        .catch((error) => {
          console.error("Error al obtener negocios:", error);
          this.permiso = 1;
          this.respuesta = false;
          this.loading.close();
        });
    },
    diagnosisProducts() {
      this.activeTab = "productos";
      this.loading = Loading.service({ text: "Cargando..." });
      const config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/diagnosticoProductos", config)
        .then((response) => {
          this.productosErroneos = response.data.response ? response.data.result || [] : [];
          this.getIdCarta();
        })
        .catch((error) => {
          console.error("Error en diagnosisProducts:", error);
          this.productosErroneos = [];
          this.loading.close();
        });
    },
    diagnosisSubproducts() {
      this.activeTab = "materias";
      this.loading = Loading.service({ text: "Cargando..." });
      const config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/diagnosticoSubproductos", config)
        .then((response) => {
          this.subproductosErroneos = response.data.response ? response.data.result || [] : [];
          this.getIdCarta();
        })
        .catch((error) => {
          console.error("Error en diagnosisSubproducts:", error);
          this.subproductosErroneos = [];
          this.loading.close();
        });
    },
    getIdCarta() {
      const config = {
        params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "general/getIdBusinessInfo", config)
        .then((response) => {
          this.idCarta = response.data.response ? response.data.result || 0 : 0;
          this.loading.close();
        })
        .catch((error) => {
          console.error("Error en getIdCarta:", error);
          this.idCarta = 0;
          this.loading.close();
        });
    },
    notificarProductoSubproductoUpdate() {
      const config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/diagnosticoGeneral", config)
        .then((response) => {
          this.getBusiness();
        })
        .catch((error) => {
          console.error("Error en notificarProductoSubproductoUpdate:", error);
          this.permiso = 1;
          this.respuesta = false;
          this.loading.close();
        });
    },
    handleBusinessChange() {
      this.permisoCarta();
      this.activeTab = "productos";
      this.diagnosisProducts();
    },
    searchProductos(query) {
      if (query) {
        const config = {
          params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt, query },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/searchProductsTpv", config)
          .then((response) => {
            this.productos = response.data.response ? response.data.result.products || [] : [];
          })
          .catch((error) => {
            console.error("Error en searchProductos:", error);
            this.productos = [];
          });
      }
    },
    abrirRelacionadorProducto(id, name) {
      this.productoId = id;
      this.productoName = name;
      this.dialogVisible = true;
    },
    guardarProducto() {
      const data = {
        idProductCarta: this.productoId,
        idProduct: this.producto.idProduct,
        jwt: this.$store.getters.jwt,
      };
      const config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      
      this.loading = Loading.service({ text: "Cargando..." });
      this.axios
        .post(this.$store.getters.apiUrl + "products/relateProductCartaToProduct", data, config)
        .then((response) => {
          this.loading.close();
          if (response.data.response) {
            this.dialogVisible = false;
            this.diagnosisProducts();
          } else {
            swal.fire("Error", response.data.message || "Error al guardar", "error");
          }
        })
        .catch((error) => {
          console.error("Error en guardarProducto:", error);
          this.loading.close();
          swal.fire("Error", "Ocurrió un error al guardar el producto", "error");
        });
    },
    abrirRelacionSubproducto(id, name) {
      this.subproductoId = id;
      this.subproductoName = name;
      this.dialogVisible2 = true;
    },
    searchMateriasPrimas(query) {
      if (query) {
        const config = {
          params: { idBusiness: this.idBusiness, jwt: this.$store.getters.jwt, query },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        this.axios
          .get(this.$store.getters.apiUrl + "delivery/searchMateriasPrimasTpv", config)
          .then((response) => {
            this.listMateriasPrimas = response.data.response ? response.data.result.materiasPrimas || [] : [];
          })
          .catch((error) => {
            console.error("Error en searchMateriasPrimas:", error);
            this.listMateriasPrimas = [];
          });
      }
    },
    guardarSubproducto() {
      const data = {
        idSubproductCarta: this.subproductoId,
        idSubproduct: this.materiaPrima.idSubproduct,
        jwt: this.$store.getters.jwt,
      };
      const config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.loading = Loading.service({ text: "Cargando..." });
      this.axios
        .post(this.$store.getters.apiUrl + "subproducts/relateSubproductCartaToSubProduct", data, config)
        .then((response) => {
          this.loading.close();
          if (response.data.response) {
            this.dialogVisible2 = false;
            this.diagnosisSubproducts();
          } else {
            swal.fire("Error", response.data.message || "Error al guardar", "error");
          }
        })
        .catch((error) => {
          console.error("Error en guardarSubproducto:", error);
          this.loading.close();
          swal.fire("Error", "Ocurrió un error al guardar el subproducto", "error");
        });
    },
    parseJwt(token) {
      try {
        return JSON.parse(atob(token.split(".")[1]));
      } catch (e) {
        return null;
      }
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
  margin-bottom: 20px;
}

.tabs-container {
  display: flex;
  border-bottom: 2px solid #ddd;
  margin-bottom: 1rem;
}

.tab {
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  font-weight: 500;
  color: #555;
}

.tab:hover, .tab.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-primary {
  background-color: #d6e9fa;
  color: #004085;
  border: 1px solid #b8daff;
}

.alert {
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.alert i {
  margin-right: 8px;
}

.table-responsive {
  margin-top: 20px;
}

.select-default {
  width: 100%;
}

.btn-spacing {
  margin-right: 12px !important; /* Fallback in case inline style is overridden */
}

.d-flex.gap-2 {
  gap: 12px !important; /* Enforce gap to ensure spacing */
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Diagnostico/DiagnosticoCarta.vue